import { Flex } from '@chakra-ui/react';
import { Text } from 'components/ui';
import { useAffiliate } from '../../../../api/affiliates/useAffiliate';

import styled from '@emotion/styled';
import { EmotionTheme } from 'theme/emotionTheme';

const GradientBox = styled('div')<{ theme?: EmotionTheme }>`
  background-image: linear-gradient(#043338, #2d6670);
`;

export const BannerBar = () => {
  const { affiliate } = useAffiliate();
  return (
    <GradientBox>
      <Flex py={3} px={{ base: 4, md: 8 }} align="center" justify="center">
        <Text
          fontSize={{ base: 'sm', md: 'lg' }}
          color="white"
          textAlign="center"
          maxW={{ base: '70%', md: '100%' }}
        >
          {affiliate?.landing_page_banner ||
            'Manage your digestive symptoms, covered by insurance'}
        </Text>
      </Flex>
    </GradientBox>
  );
};
